import { useDispatch } from "react-redux";
import { getTrackMakesAndModels } from "../../../store/slices/ProductFinder/ProductFinderSlice";

/**
 * WhatDoesThisFit Component
 * Displays a clickable "What does this fit?" link for products with specific product codes (16, 17)
 *
 * @param {Object} props - Component props
 * @param {Object} props.product - Product object containing product_code
 * @param {string} [props.className] - Additional CSS classes to apply
 * @param {string} [props.text] - Custom text to display (defaults to "What does this fit?")
 */
export default function WhatDoesThisFit({
  product,
  className = "",
  text = "What does this fit?",
}) {
    const dispatch = useDispatch();

  // Check if product code starts with 16 or 17
  const shouldShow =
    product?.product_code &&
    ["16", "17", "18"].includes(product.product_code.substring(0, 2));

  if (!shouldShow) {
    return null;
  }

  const fetchTrackMatches = (productCode) => {
    dispatch(getTrackMakesAndModels({ product_code: productCode }));
  };

  const handleClick = () => {
    if (product?.product_code) {
      fetchTrackMatches(product.product_code);
    }
  };

  return (
    <p
      onClick={handleClick}
      className={`text-[var(--primary-color)] hover:cursor-pointer hover:text-[var(--secondary-color)] ${className}`}
    >
      {text}
    </p>
  );
}
